module.exports = "/images/icons.svg?c5eb101fca1f32d184ac5e0d270e1af1";